module.exports = __webpack_public_path__ + "media/newstyle/images/icon-close-quote-a98418425ac5e29c55ed2ee92f5f609b.svg";